import React from 'react'
import { connect } from 'react-redux'
import { Breadcrumbs } from './breadcrumbs'
import {withRouter} from 'react-router-dom';
import { Redirect } from 'react-router';
import { stepsFormGrupos } from '../../service/stepsService'


const Conteiner = ({breadcrumbs, match, navegation}) =>{
  
  let redirect = null
  if((!navegation || !navegation.currentStep) && match.path !=='/vamosComecar'){
    redirect = (<Redirect to="/vamosComecar" />)
  }else 
  if(navegation.currentStep && navegation.currentStep.URL && navegation.currentStep.URL !== match.path){
    redirect = (<Redirect to={navegation.currentStep.URL} />)
  }
  return (
    <>
      <Breadcrumbs {...breadcrumbs} />
      {redirect}
    </>
  )
}


const getBreadcrumbsData = navegation =>{
  let defaultStep = {Nome:"Vamos começar!",Id:0}
  let title = "Vamos começar!";
  let steps = [{ className:""}, {className:""}]
  let number = 1;
  let isMobileMode  = window.innerWidth <= 576;

  if (navegation.currentNavegation && navegation.currentNavegation.Grupos) {
      
    let { currentNavegation, currentStep } = navegation
    let areadyActive = false
    let className ="";
    
    
    if (!currentStep || !currentStep.hasOwnProperty("Id")){
      currentStep = defaultStep
    }

    title = currentStep.Nome
    
    steps = stepsFormGrupos(currentNavegation.Grupos).map((grupo, index) =>{
      
      className = "breadcrumb-done"
      
      if (areadyActive)
        className = ""
    
      if (grupo.Id === currentStep.Id) {
        className = "breadcrumb-active"
        areadyActive = true
        number = index + 1;
      }
      
      return {className};
    })

    
  }
  
  if(isMobileMode){
    steps = [{className:"breadcrumb-text", text: steps.length }];
  }

  return {title, steps, number};
}

const mapStateToProps = (state) => ({
  breadcrumbs:getBreadcrumbsData(state.navegationStepsReducer),
  navegation:state.navegationStepsReducer
})

export default connect(
  mapStateToProps
)(withRouter(Conteiner))
